import { QueryClient } from '@tanstack/react-query';
import { ApiError, NetworkError } from '../lib/api/errors';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Don't hammer the server on a deterministic failure.
          if (error instanceof ApiError) return false;
          if (error instanceof NetworkError) return failureCount < 2;
          return failureCount < 1;
        },
      },
      mutations: { retry: false },
    },
  });
}
